import React from "react";
import { Col } from "react-bootstrap";
import Nom035Person from "./Nom035Person";
import "./Nom035PeopleList.css";

function Nom035PeopleList({ people, language }) {
  return (
    <Col className="nom035-people-list">
      {people.map((element) => (
        <Nom035Person
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profile={element.profile}
        />
      ))}
    </Col>
  );
}

export default Nom035PeopleList;
